<template>
  <banner :showing="showing">
    <div class="mr-3">
      By using this site, you agree to our
      <a
        href="https://nanome.ai/public-src/downloads/Nanome-Privacy.pdf"
        target="_blank"
        >Privacy Policy</a
      >,
      <br />
      <a
        href="https://nanome.ai/public-src/downloads/Nanome-TOS.pdf"
        target="_blank"
        >Terms of Service</a
      >, and the use of cookies.
    </div>
    <b-btn @click="hide" variant="primary">I understand</b-btn>
  </banner>
</template>

<script>
import Banner from "./Banner";

export default {
  components: { Banner },

  data: () => ({
    showing: false
  }),

  created() {
    this.showing = !localStorage.getItem("home-tos-1");
  },

  methods: {
    hide() {
      this.showing = false;
      localStorage.setItem("home-tos-1", true);
    }
  }
};
</script>
